<strong class="title underline">{{ title }} {{ orderId }}</strong>
<h5 class="sub-title" *ngIf="isFix">{{ subTitle }} {{ basedOnOrderId }}(*)</h5>

<p class="table-title">פרטי המזמין:</p>
<table class="table-outer-border">
  <tbody>
    <tr>
      <td style="width: 50%">
        <p>
          <strong
            ><span class="underline">שם המזמין:</span>
            {{ company?.name }}</strong
          >
        </p>
        <p>
          <strong
            ><span class="underline">מענו:</span> {{ company?.address }}</strong
          >
        </p>
        <p>
          <strong
            ><span class="underline">ח.פ:</span>
            {{ company?.companyNumber }}</strong
          >
        </p>
        <p>
          <strong
            ><span class="underline">תאריך ההזמנה:</span>
            {{ order.createdAt | date : 'shortDate' : 'GMT+3' }}</strong
          >
        </p>
      </td>
      <td style="width: 50%">
        <p>
          <strong
            ><span class="underline">לידי:</span> {{ contact?.name }}</strong
          >
        </p>
        <br />
        <br />
        <p>
          <strong
            ><span class="underline">מייל:</span> {{ contact?.email }}</strong
          >
        </p>
      </td>
    </tr>
  </tbody>
</table>

<br />
<p class="table-title">תאור המערכת הנבדקת:</p>
<table>
  <tbody>
    <tr>
      <td style="width: 100%">
        <p>
          <strong
            >{{ systemDescription
            }}<span *ngIf="systemSubDescription"
              >:
              <span class="underline">{{
                inspection.fireExtinguishingType
              }}</span></span
            ></strong
          >
        </p>
        <p>
          <strong
            ><span class="underline">שם הפרויקט:</span>
            {{ subProject.name }}</strong
          >
        </p>
        <p>
          <strong>
            <span class="underline">כתובת הפרויקט:</span> {{ project.street }}
            {{ project.buildingNumber
            }}<span *ngIf="project.street || project.buildingNumber">, </span
            >{{ project.city?.name }}</strong
          >
        </p>
        <p *ngIf="subProject.block || subProject.plot || subProject.lot">
          <strong>
            <span class="underline" *ngIf="subProject.block"
              >גוש:
              <span class="address-details"> {{ subProject.block }}</span></span
            >
            <span class="underline" *ngIf="subProject.plot"
              >חלקה:
              <span class="address-details"> {{ subProject.plot }}</span></span
            >
            <span class="underline" *ngIf="subProject.lot"
              >מגרש:
              <span class="address-details"> {{ subProject.lot }}</span></span
            >
          </strong>
        </p>
      </td>
    </tr>
  </tbody>
</table>

<br />
<p class="table-title">מהות הבדיקה:</p>
<table>
  <tbody>
    <tr>
      <td style="width: 100%">
        <p>
          <strong style="display: block">{{ inspection.standard }}</strong>
        </p>
        <p *ngIf="inspection?.standardExtraText">
          <strong>{{ inspection.standardExtraText }}</strong>
        </p>
        <p *ngIf="inspection?.inspectionCount">
          <strong>{{ inspection.inspectionCount }}</strong>
        </p>
        <p>
          <strong>
            <span class="underline">הבדיקה נערכה בתאריך:</span>
            <span class="address-details">
              {{
                inspection.inspectionDate | date : 'shortDate' : 'GMT+3'
              }}</span
            >
            <span class="underline" *ngIf="inspection.representativeName"
              >מלווה הבדיקה:</span
            >
            <span class="address-details" *ngIf="inspection.representativeName">
              {{ inspection.representativeName }}</span
            >
          </strong>
        </p>
      </td>
    </tr>
  </tbody>
</table>

<br />
<p class="table-title">סיכום:</p>
<table>
  <tbody>
    <tr>
      <td style="width: 100%">
        <ol>
          <li
            *ngFor="
              let item of inspection?.summaryNotes
                | filterBy : ['addNotesToReport'] : true
            "
          >
            <strong class="underline" style="display: table-cell">{{
              item.notes
            }}</strong>
            <ol style="margin-right: 15px">
              <li
                *ngFor="
                  let subNote of item.subNotes
                    | filterBy : ['addNotesToReport'] : true
                "
              >
                <strong class="underline" style="display: table-cell">{{
                  subNote.notes
                }}</strong>
              </li>
            </ol>
          </li>
        </ol>
      </td>
    </tr>
  </tbody>
</table>

<br />
<br />

<authority-labs-certificate-signatures
  [assignee]="assignee"
  [approval]="approval"
  [date]="date"
  *ngIf="order?.isApproved"
></authority-labs-certificate-signatures>

<br />
<p>
  <strong><span>העתקים: שרותי הכבאות</span></strong>
</p>
